import { styled, Switch, TableCell, tableCellClasses } from '@mui/material'
import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react'
import { InvoiceLineItem } from 'store/invoices/invoices.types'

interface IProps {
  checked: boolean
  line: InvoiceLineItem
  setLines: Dispatch<SetStateAction<InvoiceLineItem[] | undefined>>
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme.palette.common.white,
    // padding: '4px 12px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // padding: '4px 12px',
  },
}))

const InvoiceEditTableTax = ({ checked, line, setLines }: IProps) => {
  const [taxChecked, setTaxChecked] = useState(checked)

  const handleTax = (checked: boolean) => {
    setLines((prevLines) =>
      prevLines?.map((prevLine) =>
        prevLine.id === line.id ? { ...prevLine, tax: checked } : prevLine
      )
    )
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setTaxChecked(event.target.checked)
    handleTax(event.target.checked)
  }

  return (
    <StyledTableCell sx={{ minWidth: 150 }}>
      <Switch checked={taxChecked} onChange={handleChange} />
    </StyledTableCell>
  )
}

export default InvoiceEditTableTax
